import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  infoBanner: {
    width: '100%',
    position: 'relative',
    backgroundColor: theme.palette.white,
    padding: '80px 0 60px 0',
    [theme.breakpoints.down('lg')]: {
      padding: '50px 0',
    },
    [theme.breakpoints.down('md')]: {
      padding: '40px 0',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '30px 0',
    },
  },
  infoBannerContent: {
    maxWidth: '1080px',
    margin: 'auto',
    [theme.breakpoints.down('lg')]: {
      maxWidth: '940px',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '700px',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      padding: '0 20px 0 20px',
    },
  },
  infoBannerContentTitle: {
    fontSize: theme.typography.pxToRem(36),
    fontFamily: theme.typography.proxima.semiBold,
    color: theme.palette.blue1,
    lineHeight: theme.typography.pxToRem(54),
    marginBottom: '10px',
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(30),
      lineHeight: theme.typography.pxToRem(45),
    },
    [theme.breakpoints.down('sm')]: {
      lineHeight: theme.typography.pxToRem(36),
      fontSize: theme.typography.pxToRem(24),
    },
  },
  infoBannerContentGuests: {
    fontSize: theme.typography.pxToRem(24),
    color: theme.palette.grey1,
    lineHeight: theme.typography.pxToRem(36),
    marginBottom: '10px',
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(24),
    },
    [theme.breakpoints.down('md')]: {
      lineHeight: theme.typography.pxToRem(27),
      fontSize: theme.typography.pxToRem(18),
    },
  },
  infoBannerContentReservation: {
    fontSize: theme.typography.pxToRem(18),
    color: theme.palette.grey1,
    lineHeight: theme.typography.pxToRem(27),
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(18),
    },
    [theme.breakpoints.down('md')]: {
      lineHeight: theme.typography.pxToRem(24),
      fontSize: theme.typography.pxToRem(16),
    },
  },
}));

export default useStyles;
